import React, { useState, useEffect } from 'react';
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import { BoxWrapper } from 'components/Base';
import Icons from 'components/Icons';
import LinkCard from './LinkCard';
import SystemUpdatesModal from './SystemUpdatesModal';
import NeedSupportModal from './NeedSupportModal';
import { useHistory } from 'react-router-dom';
import Routes from 'consts/routes';
import { Grid } from '@material-ui/core';

import {
  ForumOutlined as ForumOutlinedIcon,
  InfoOutlined as InfoOutlinedIcon
} from '@material-ui/icons';
import { openPopupWidget } from 'react-calendly';
import { QuestionMarkOutlined } from '@mui/icons-material';
import api from 'api';

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      overflow: 'hidden',
      fontSize: '0.9rem'
    },
    bubble: {
      height: '20px',
      width: '20px',
      borderRadius: '50%',
      backgroundColor: 'red',
      position: 'absolute',
      bottom: '10px',
      right: 0,
      top: 0,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center'
    }
  })
);

const ResourcesTile = () => {
  const theme = useTheme() as any;
  const classes = useStyles();
  const history = useHistory();
  const [isSystemUpdateModalOpen, setIsSystemUpdateModalOpen] = useState(false);
  const [isNeedSupportModalOpen, setIsNeedSupportModalOpen] = useState(false);
  const [releaseNotes, setReleaseNotes] = useState([] as any);
  const [hasUnseenUpdates, setHasUnseenUpdates] = useState(false);

  useEffect(() => {
    api.getSystemUpdates().then(response => {
      setReleaseNotes(response.data.release_notes);
      setHasUnseenUpdates(response.data.has_unseen);
    });
  }, []);

  return (
    <BoxWrapper title="Resources" noBorder className={classes.box}>
      <Grid
        container
        spacing={3}
        justifyContent="space-between"
        alignItems="stretch"
        style={{ height: '100%' }}
      >
        <Grid item xs={6}>
          <LinkCard
            icon={
              <ForumOutlinedIcon
                style={{
                  fontSize: 48,
                  color: theme.palette.baseColors.secondary
                }}
              />
            }
            onClick={() => {
              setIsNeedSupportModalOpen(true);
            }}
          >
            <div>Need support</div>
          </LinkCard>
          <LinkCard
            icon={
              <Icons.Support
                style={{
                  fontSize: 48,
                  fill: theme.palette.baseColors.secondary
                }}
              />
            }
            onClick={() =>
              openPopupWidget({ url: 'https://calendly.com/fintegrate/demo' })
            }
          >
            <div>Book a Demo</div>
          </LinkCard>
        </Grid>
        <Grid item xs={6}>
          <LinkCard
            icon={
              <div style={{ position: 'relative' }}>
                {hasUnseenUpdates && <div className={classes.bubble}></div>}
                <InfoOutlinedIcon
                  style={{
                    fontSize: 48,
                    color: theme.palette.baseColors.secondary
                  }}
                />
              </div>
            }
            onClick={() => {
              setIsSystemUpdateModalOpen(true);
            }}
          >
            <div>System updates</div>
          </LinkCard>
          <LinkCard
            icon={
              <QuestionMarkOutlined
                style={{
                  fontSize: 48,
                  color: theme.palette.baseColors.secondary
                }}
              />
            }
            onClick={() => history.push(Routes.GLOSSARY)}
          >
            <div>Glossary</div>
          </LinkCard>
        </Grid>
      </Grid>
      <NeedSupportModal
        isModalOpen={isNeedSupportModalOpen}
        closeModal={() => setIsNeedSupportModalOpen(false)}
      />
      <SystemUpdatesModal
        isModalOpen={isSystemUpdateModalOpen}
        closeModal={() => setIsSystemUpdateModalOpen(false)}
        releaseNotes={releaseNotes}
        setHasUnseenUpdates={setHasUnseenUpdates}
      />
    </BoxWrapper>
  );
};

export default ResourcesTile;
